import { Spinner } from "react-bootstrap";


export default function LoadingScreen() {
  return (
    <div className="d-flex justify-content-center align-items-center mt-5">
        <span><Spinner animation="border" variant="primary" data-testid="loadingScreenSpinner" /> <span style={{fontSize: "3rem"}}>Loading...</span></span>
    </div>
  )
}